var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"pa-10 pb-0",attrs:{"md":"12","sm":"12","lg":"12"}},[_c('v-card',{staticClass:"containerbox",attrs:{"elevation":"0","height":"80%"}},[_c('breadcrumbComp',{attrs:{"mainPage":"Home","refresh":_vm.refresh,"backSlash":_vm.backSlash,"resetFunction":_vm.resetFunction,"hideFav":_vm.hideFav}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }